import React from 'react';
import ProspectingGuidedSetup from '../components/Prospecting/onboarding/ProspectingGuidedSetup';

export default function ProspectingGuidedSetupPage() {
  return <ProspectingGuidedSetup />;
}
